/** 订单预评级结果类型 */
export interface OrderPreRating {
  id: number;
  orderNo: string;
  /** T1 风控评分 (0~100) */
  riskScore: number;
  /** 风险判定: HIGH | LOW | UNKNOWN */
  riskLevel: 'HIGH' | 'LOW' | 'UNKNOWN';
  /** 扣分项明细 */
  riskDeductions: RiskDeductionItem[];
  /** T2 预估利润率 */
  profitRate: number;
  /** 利润判定: HIGH | LOW | UNKNOWN */
  profitLevel: 'HIGH' | 'LOW' | 'UNKNOWN';
  /** T3 综合评级: A | B | C | D | UNKNOWN */
  comprehensiveRating: 'A' | 'B' | 'C' | 'D' | 'UNKNOWN';
  createdAt: string;
  updatedAt: string;
}

/** 风控扣分项 */
export interface RiskDeductionItem {
  reason: string;
  score: number;
}

export interface OrderPreRiskHitItem {
  code: string;
  name: string;
  deductScore: number;
  source: string;
  evidence: string;
  message: string;
  sort: number;
}

export interface OrderPreRiskDetail {
  level: 'HIGH' | 'LOW' | 'UNKNOWN' | string;
  baseType: string;
  baseScore: number;
  score: number;
  threshold: number;
  deductionTotal: number;
  hitItems: OrderPreRiskHitItem[];
  unknownReasons?: string[];
}

export interface OrderPreProfitMode {
  mode: string;
  ratio: number;
  sampleOrderCount: number;
  thresholdProfitRate: number;
}

export interface OrderPreProfitDetail {
  level: 'HIGH' | 'LOW' | 'UNKNOWN' | string;
  rate: number;
  packageType: string;
  thresholdRate: number;
  mainstreamMode: string;
  mainstreamModeRatio: number;
  otherModes: OrderPreProfitMode[];
}

export interface OrderPreRatingDetail {
  orderNo: string;
  risk: OrderPreRiskDetail;
  profit: OrderPreProfitDetail;
  comprehensiveRating: 'A' | 'B' | 'C' | 'D' | 'UNKNOWN';
  updatedAt: string;
}

/** 综合评级颜色映射 */
export const COMPREHENSIVE_RATING_COLOR: Record<string, string> = {
  A: '#52c41a',
  B: '#1890ff',
  C: '#faad14',
  D: '#ff4d4f',
  UNKNOWN: '#999',
};

/** 风险等级标签映射 */
export const RISK_LEVEL_MAP: Record<string, { label: string; color: string }> = {
  HIGH: { label: '高风险', color: '#ff4d4f' },
  LOW: { label: '低风险', color: '#52c41a' },
  UNKNOWN: { label: '待评级', color: '#98a2b3' },
};

/** 利润等级标签映射 */
export const PROFIT_LEVEL_MAP: Record<string, { label: string; color: string }> = {
  HIGH: { label: '优质', color: '#52c41a' },
  LOW: { label: '一般', color: '#faad14' },
  UNKNOWN: { label: '待评级', color: '#98a2b3' },
};

export const RISK_BASE_TYPE_MAP: Record<string, string> = {
  MUST_BLIND: '盲发必发',
  BLIND: '盲发',
  PASS: '通过',
  PRE_PAY: '预收',
  HIGH_RISK: '高风险',
  UNKNOWN: '待评级',
};

export const PROFIT_MODE_MAP: Record<string, string> = {
  EARLY_RETURN: '提前归还',
  EARLY_BUYOUT: '提前买断',
  END_RETURN: '到期归还',
  END_BUYOUT: '到期买断',
};
